import { createRouter, createWebHistory } from 'vue-router'
import layout from '@/layout/index'
const routes = [
    {
        path: '',
        redirect: '/home',
        children: [
            {
                path: '/home',
                component: () => import('@/views/index/HomeView.vue'),
                name: 'login'
            }
        ]
    },
    {
        path: '',
        redirect: '/mapZhe',
        children: [
            {
                path: '/mapZhe',
                component: () => import('@/views/index/mapZhe.vue'),
                name: 'mapZhe'
            }
        ]
    },
    {
        path: '',
        redirect: '/wectInfo',
        children: [
            {
                path: '/wectInfo',
                component: () => import('@/views/index/wectInfo.vue'),
                name: '微信推送'
            }
        ]
    },
    {
        path: '/index',
        component: layout,
        children: [
            {
                path: '',
                component: () => import('@/views/index/IndexView.vue'),
                name: 'Index',
                meta: { title: '首页', affix: true, breadcrumb: false }
            }
        ]
    },
    {
        path: '/dashboard',
        component: layout,
        children: [
            {
                path: '',
                component: () => import('@/views/index/dashboard.vue'),
                name: 'dashboard',
                meta: { title: '首页', affix: true, breadcrumb: false }
            }
        ]
    },
    {
        path: '/tasks',
        name: 'Ai机器人',
        component: layout,
        children: [
            {
                path: '/tasks',
                component: () => import('@/views/tasks/TasksView.vue'),
                name: 'tasks',
                meta: { title: '任务管理', affix: true, breadcrumb: true }
            },
            {
                path: '/taskTemplats',
                component: () => import('@/views/tasks/taskTemplatView.vue'),
                name: 'taskTemplats',
                meta: { title: '任务模板', affix: true, breadcrumb: true }
            },
            {
                path: '/TaskInfo',
                component: () => import('@/components/TaskInfo.vue'),
                name: 'TaskInfo',
                meta: { title: '任务详情', affix: true, breadcrumb: true }
            },
            {
                path: '/callStatistics',
                component: () => import('@/views/tasks/callStatistics.vue'),
                name: 'callStatistics',
                meta: { title: '拨打统计', affix: true, breadcrumb: true }
            },
            {
                path: '/lines',
                component: () => import('@/views/index/LineView.vue'),
                name: 'lines',
                meta: { title: '线路管理', affix: true, breadcrumb: true }
            },
            {
                path: '/newLines',
                component: () => import('@/views/index/newLineView.vue'),
                name: 'newLines',
                meta: { title: '线路管理', affix: true, breadcrumb: true }
            },
            {
                path: '/seatsLine',
                component: () => import('@/views/index/seatsLine.vue'),
                name: 'seatsLine',
                meta: { title: '坐席管理', affix: true, breadcrumb: true }
            },
            {
                path: '/asrs',
                component: () => import('@/views/index/AsrView.vue'),
                name: 'asrs',
                meta: { title: 'ASR管理', affix: true, breadcrumb: true }
            },
            {
                path: '/chargeLogs',
                component: () => import('@/views/index/ChargeLogView.vue'),
                name: 'chargeLogs',
                meta: { title: '充值记录', affix: true, breadcrumb: true }
            },
            {
                path: '/callrecord',
                component: () => import('@/views/tasks/CallRecordView.vue'),
                name: 'callrecord',
                meta: { title: '通话记录', affix: true, breadcrumb: true }
            },
            {
                path: '/talkscripts',
                component: () => import('@/views/tasks/TalkScriptViewCopy.vue'),
                name: 'talkscripts',
                meta: {
                    title: '话术管理',
                    affix: true,
                    breadcrumb: true,
                    keepAlive: false
                }
            },
            {
                path: '/manualConfig',
                component: () => import('@/views/manualConfig/index.vue'),
                name: 'manualConfig',
                meta: { title: '人工配置', affix: true, breadcrumb: true }
            },
            {
                path: '/robotchairs',
                component: () => import('@/views/tasks/RobotChairView.vue'),
                name: 'robotchairs',
                meta: { title: '人机互动', affix: true, breadcrumb: true }
            },
            {
                path: '/AgentMonitoring',
                component: () => import('@/views/tasks/AgentMonitoring.vue'),
                name: 'AgentMonitoring',
                meta: { title: '坐席监控', affix: true, breadcrumb: true }
            },
            {
                path: '/grapView',
                // component: () => import("@/views/tasks/compoents/grapView.vue"),
                component: () => import('@/views/tasks/compoents/grapViewRefactor.vue'),
                name: 'grapView',
                meta: { title: '话术编辑', affix: true, breadcrumb: true }
            },
            {
                path: '/line',
                component: () => import('@/views/index/compoents/line.vue'),
                name: 'line',
                meta: { title: '线路列表', affix: true, breadcrumb: true }
            },
            {
                path: '/lineInfo',
                component: () => import('@/views/index/compoents/lineInfo.vue'),
                name: 'lineInfo',
                meta: { title: '线路列表', affix: true, breadcrumb: true }
            },
            {
                path: '/xiafaLine',
                component: () => import('@/views/xiafaLin/xiafaLinInfo.vue'),
                name: 'xiafaLine',
                meta: { title: '下发详情', affix: true, breadcrumb: true }
            },
            {
                path: '/newXiafaLine',
                component: () => import('@/views/xiafaLin/newXiafaLinInfo.vue'),
                name: 'newXiafaLine',
                meta: { title: '下发详情', affix: true, breadcrumb: true }
            },
            {
                path: '/wechatPushRecord',
                component: () => import('@/views/tasks/WechatRecordView.vue'),
                name: 'wechatPushRecord',
                meta: { title: '微信推送记录', affix: true, breadcrumb: true }
            },
            {
                path: '/blackPhone',
                component: () => import('@/views/blackPhone/index.vue'),
                name: 'blackPhone',
                meta: { title: '电话黑名单', affix: true, breadcrumb: true }
            }
        ]
    },
    {
        path: '/users',
        name: '用户中心',
        component: layout,
        children: [
            {
                path: '/users',
                component: () => import('@/views/index/UsersView.vue'),
                name: 'users',
                meta: { title: '用户管理', affix: true, breadcrumb: true }
            },
            {
                path: '/seatExtensionView',
                component: () => import('@/views/index/seatExtensionView.vue'),
                name: 'seatExtensionView',
                meta: { title: '坐席分机', affix: true, breadcrumb: true }
            },
            {
                path: '/smsChanel',
                component: () => import('@/views/users/smsChanel.vue'),
                name: 'smsChanel',
                meta: { title: '短信通道', affix: true, breadcrumb: true }
            },
            {
                path: '/consumStatis',
                component: () => import('@/views/users/consumStatis/index.vue'),
                name: 'consumStatis',
                meta: { title: '消费统计', affix: true, breadcrumb: true }
            },
            {
                path: '/operationRecord',
                component: () => import('@/views/users/operationRecord/index.vue'),
                name: 'operationRecord',
                meta: { title: '操作记录', affix: true, breadcrumb: true }
            },
            {
                path: '/rechargeRecord',
                component: () => import('@/views/users/rechargeRecord/index.vue'),
                name: 'rechargeRecord',
                meta: { title: '充值记录', affix: true, breadcrumb: true }
            },
            {
                path: '/consumptionDetails',
                component: () => import('@/views/users/consumptionDetails/index.vue'),
                name: 'consumptionDetails',
                meta: { title: '消费明细', affix: true, breadcrumb: true }
            },
            {
                path: '/telAsr',
                component: () => import('@/views/users/telAsr/index.vue'),
                name: 'telAsr',
                meta: { title: 'asr识别', affix: true, breadcrumb: true }
            }
        ]
    },
    {
        path: '/customs',
        name: 'CRM客户',
        component: layout,
        children: [
            {
                path: '/dataCenter',
                component: () => import('@/views/crm/DataCenterView.vue'),
                name: 'dataCenter',
                meta: { title: '数据中心', affix: true, breadcrumb: true }
            },
            {
                path: '/customer',
                component: () => import('@/views/crm/CustomerView.vue'),
                name: 'customer',
                meta: { title: '客户管理', affix: true, breadcrumb: true }
            },
            {
                path: '/openSea',
                component: () => import('@/views/crm/OpenSeaView.vue'),
                name: 'openSea',
                meta: { title: '全部公海', affix: true, breadcrumb: true }
            },
            {
                path: '/crmWechat',
                component: () => import('@/views/crm/WechatView.vue'),
                name: 'crmWechat',
                meta: { title: '微信管理', affix: true, breadcrumb: true }
            },
            {
                path: '/dealRecord',
                component: () => import('@/views/crm/DealRecordView.vue'),
                name: 'dealRecord',
                meta: { title: '成交记录', affix: true, breadcrumb: true }
            },
            {
                path: '/setting',
                component: () => import('@/views/crm/SettingView.vue'),
                name: 'setting',
                meta: { title: '设置管理', affix: true, breadcrumb: true }
            },
            {
                path: '/organization',
                component: () => import('@/views/crm/OrganizationView.vue'),
                name: 'organization',
                meta: { title: '组织架构', affix: true, breadcrumb: true }
            }
        ]
    },
    {
        path: '/taskManage',
        name: '群呼系统',
        component: layout,
        children: [
            {
                path: '/taskManage',
                component: () => import('@/views/groupcall/taskManage.vue'),
                name: 'taskManage',
                meta: { title: '任务管理', affix: true, breadcrumb: true }
            },
            {
                path: '/GroupCustomerView',
                component: () => import('@/views/groupcall/GroupCustomerView.vue'),
                name: 'GroupCustomerView',
                meta: { title: '客户管理', affix: true, breadcrumb: true }
            },
            {
                path: '/lineManage',
                component: () => import('@/views/groupcall/lineManage.vue'),
                name: 'lineManage',
                meta: { title: '线路管理', affix: true, breadcrumb: true }
            },
            {
                path: '/seatslineManage',
                component: () => import('@/views/groupcall/seatslineManage.vue'),
                name: 'seatslineManage',
                meta: { title: '坐席管理', affix: true, breadcrumb: true }
            },
            {
                path: '/configManage',
                component: () => import('@/views/groupcall/configManage.vue'),
                name: 'configManage',
                meta: { title: '群呼配置', affix: true, breadcrumb: true }
            },
            {
                path: '/callHistory',
                component: () => import('@/views/groupcall/callHistory.vue'),
                name: 'callHistory',
                meta: { title: '通话记录', affix: true, breadcrumb: true }
            },
            {
                path: '/monitoringCalls',
                component: () => import('@/views/groupcall/compoents/monitoringCalls.vue'),
                name: 'monitoringCalls',
                meta: { title: '监控通话', affix: true, breadcrumb: true }
            }
        ]
    },
    {
        path: '/config',
        name: '系统配置',
        component: layout,
        children: [
            {
                path: '/config',
                component: () => import('@/views/system/ConfigView.vue'),
                name: 'config',
                meta: { title: '菜单列表', affix: true, breadcrumb: true }
            },
            {
                path: '/systemsetting',
                component: () => import('@/views/system/SystemSettingView.vue'),
                name: 'systemsetting',
                meta: { title: '基础设置', affix: true, breadcrumb: true }
            },
            {
                path: '/roles',
                component: () => import('@/views/system/RolesView.vue'),
                name: 'roles',
                meta: { title: '角色列表', affix: true, breadcrumb: true }
            },
            {
                path: '/wechatQord',
                component: () => import('@/views/system/wechatQord.vue'),
                name: 'wechatQord',
                meta: { title: '微信绑定', affix: true, breadcrumb: true }
            },
            {
                path: '/wechat',
                component: () => import('@/views/system/WechatAccountView.vue'),
                name: 'wechat',
                meta: { title: '微信公众号', affix: true, breadcrumb: true }
            },
            {
                path: '/recording',
                component: () => import('@/views/system/TelSoundRecordingView.vue'),
                name: 'recording',
                meta: { title: '合成录音', affix: true, breadcrumb: true }
            },
            {
                path: '/operate',
                component: () => import('@/views/system/OperateLogsView.vue'),
                name: 'operate',
                meta: { title: '操作记录', affix: true, breadcrumb: true }
            },
            {
                path: '/authView',
                component: () => import('@/components/authView.vue'),
                name: 'authView',
                meta: { title: '权限配置', affix: true, breadcrumb: true }
            },
            {
                path: '/notice',
                component: () => import('@/views/system/notice.vue'),
                name: 'notice',
                meta: { title: '发布公告', affix: true, breadcrumb: true }
            },
            {
                path: '/whitelist',
                component: () => import('@/views/system/whitelist.vue'),
                name: 'whitelist',
                meta: { title: '黑名单', affix: true, breadcrumb: true }
            }
        ]
    },
    {
        path: '/dissingClues',
        name: '大数据',
        component: layout,
        children: [
            {
                path: '/dissingClues',
                component: () => import('@/views/bigData/dissingClues.vue'),
                name: 'dissingClues',
                meta: { title: '挖掘线索', affix: true, breadcrumb: true }
            },
            {
                path: '/mapSearch',
                component: () => import('@/views/bigData/mapSearch.vue'),
                name: 'mapSearch',
                meta: { title: '地图搜索', affix: true, breadcrumb: true }
            },
            {
                path: '/fsea',
                component: () => import('@/views/bigData/fsea.vue'),
                name: 'fsea',
                meta: { title: '公海', affix: true, breadcrumb: true }
            },
            {
                path: '/frecycle',
                component: () => import('@/views/bigData/frecycle.vue'),
                name: 'frecycle',
                meta: { title: '回收站', affix: true, breadcrumb: true }
            },
            {
                path: '/fpool',
                component: () => import('@/views/bigData/fpool.vue'),
                name: 'fpool',
                meta: { title: '我的线索', affix: true, breadcrumb: true }
            },
            {
                path: '/download',
                component: () => import('@/views/bigData/download.vue'),
                name: 'download',
                meta: { title: '下载导出', affix: true, breadcrumb: true }
            },
            {
                path: '/ftask',
                component: () => import('@/views/bigData/ftask.vue'),
                name: 'ftask',
                meta: { title: '任务', affix: true, breadcrumb: true }
            },
            {
                path: '/account',
                component: () => import('@/views/bigData/account.vue'),
                name: 'account',
                meta: { title: '账户管理', affix: true, breadcrumb: true }
            },
            {
                path: '/thread',
                component: () => import('@/views/bigData/thread.vue'),
                name: 'thread',
                meta: { title: '商机助手', affix: true, breadcrumb: true }
            },
            {
                path: '/dataTwo',
                component: () => import('@/views/bigData/dataTwo.vue'),
                name: 'dataTwo',
                meta: { title: '挖掘线索', affix: true, breadcrumb: true }
            }
        ]
    },
    // 公开的页面
    {
        path: '/public_task',
        component: () => import('@/views/tasks/TasksView.vue'),
        name: 'public_task',
        meta: { title: '任务管理', affix: true, breadcrumb: true }
    },
    {
        path: '/public_line',
        component: () => import('@/views/index/newLineView.vue'),
        name: 'public_line',
        meta: { title: '线路管理', affix: true, breadcrumb: true }
    },
    {
        path: '/public_call',
        component: () => import('@/views/tasks/CallRecordView.vue'),
        name: 'public_call',
        meta: { title: '通话记录', affix: true, breadcrumb: true }
    },
    {
        path: '/public_trick',
        component: () => import('@/views/tasks/TalkScriptViewCopy.vue'),
        name: 'public_trick',
        meta: {
            title: '话术管理',
            affix: true,
            breadcrumb: true,
            keepAlive: false
        }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: routes
})

export default router
